import { Ed25519KeyIdentity } from '@icp-sdk/core/identity'
import { Secp256k1KeyIdentity } from '@icp-sdk/core/identity/secp256k1'
import { arrayBufferToBase64 } from '../arrayBuffer'
import { fromHex, toHex } from '../hex'

const PEM_BEGIN = `-----BEGIN EC PARAMETERS-----
BgUrgQQACg==
-----END EC PARAMETERS-----
-----BEGIN EC PRIVATE KEY-----`

const PEM_END = '-----END EC PRIVATE KEY-----'

const PRIV_KEY_INIT = '30740201010420'

const KEY_SEPARATOR = 'a00706052b8104000aa144034200'

export const secp256k1ToPem = (identity: Secp256k1KeyIdentity | Ed25519KeyIdentity) => {
  const { secretKey, publicKey } = identity.getKeyPair()

  const rawPrivateKey = toHex(secretKey)
  const rawPublicKey = toHex(publicKey.toRaw!())

  return `${PEM_BEGIN}\n${arrayBufferToBase64(
    fromHex(`${PRIV_KEY_INIT}${rawPrivateKey}${KEY_SEPARATOR}${rawPublicKey}`)
  )}\n${PEM_END}`
}
